import { Stack, Typography, Tooltip, IconButton, Divider } from '@mui/material';
import { useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@/components/accordion';
import { Icon } from '@/components/shared/icon';

export const SummaryDrawer = <T,>({
  entityType,
  items,
  renderItem,
  itemKey,
  onRemove,
  clearAll,
}: {
  entityType: string;
  items: T[];
  onRemove: (item: T) => void;
  renderItem: (item: T) => React.ReactNode;
  itemKey: (item: T) => string;
  clearAll: () => void;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      onChange={items.length ? () => setExpanded((state) => !state) : undefined}
      className='p-0 m-0 flex flex-col'
      sx={{
        maxHeight: 'calc(100% - 60px)',
        backgroundColor: 'var(--mui-palette-background-paper)',

        '& .MuiCollapse-root': {
          backgroundColor: 'var(--mui-palette-background-paper)',
          position: 'relative',
          overflow: 'auto',
        },
      }}
    >
      <AccordionSummary
        className='min-h-[64px] h-[64px] px-[24px]'
        sx={{
          boxShadow: '0px 10px 30px 0px rgba(0, 0, 0, 0.10)',
        }}
      >
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          className='w-full py-[16px]'
        >
          <Typography>
            {`${items.length} ${items.length === 1 ? entityType : `${entityType}${entityType.endsWith('s') ? 'es' : 's'}`} selected`}
          </Typography>
          <Tooltip title='Clear all'>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                clearAll();
                setExpanded(false);
              }}
            >
              <i className='material-symbols-filter-alt-off-outline-rounded text-textPrimary h-[18px] w-[18px]'></i>
            </IconButton>
          </Tooltip>
        </Stack>
      </AccordionSummary>
      <AccordionDetails className='p-0 overflow-auto'>
        <Stack className='my-[12px]' divider={<Divider />}>
          {items.map((item) => (
            <Stack
              direction='row'
              alignItems='center'
              key={itemKey(item)}
              justifyContent='space-between'
              className='px-[24px] py-[8px]'
            >
              {renderItem(item)}
              <Icon
                onClick={() => {
                  if (items.length === 1) {
                    setExpanded(false);
                  }
                  onRemove(item);
                }}
                iconClass='material-symbols-close-rounded'
              />
            </Stack>
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
